<template>
  <div class="kurama-select" :tabindex="tabindex" @blur="masOptions = false; interacionSelect()">
    <div class="selected" :class="{ masOptions: masOptions, 'select-disable' : disable}" @click="seeList()">
        <input type="text" @keydown="clickDownUpSelect($event)" @blur="clickOutsideSelect()" v-model.trim="inputBuscar" class="kurama-select-input" :placeholder="placeholder" :disabled="disable">
    </div>
    <div :id="idSelect" class="items" :class="{ selectHide: !masOptions }" :style="{height: hSelect, maxHeight: mHSelect}">
      <div v-for="(option,i) of buscarInOptions" :id="i" :key="i" @click="indexOption=option.text.trim(); seleccionado = option;masOptions = false;$emit('KuramaSelect', option); inputBuscar = seleccionado.text.trim();">
        {{ option.text }}
      </div>
      <div class="nullOption" v-if="buscarInOptions.length == 0">
        Ninguna coincidencia
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder:{
      type: String,
      default: 'Seleccionar opción'
    },
    disable:{
      type: Boolean,
      default: false
    },
    idSelect:{
      type: String,
      default: 'select'
    },
    options: {
      type: [],
      required: true,
    },
    values:{
      type: Number,
      required: false,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
 created(){
    
    window.scrollTo(0, 0);
  },
  data() {
    return {
      inputBuscar:'',
      seleccionado: [],
      masOptions: false,
      mHSelect: 'none',
      indexOption: null,
    };
  },
computed:{
        buscarInOptions(){ 
            if(!this.inputBuscar){return this.options}
            if (this.inputBuscar !="") {
              return this.options.filter(x=> x.text ? x.text.toLowerCase().includes(this.inputBuscar.toLowerCase()) : '' );
            }
            return this.options;
        },
        hSelect(){
          if (this.inputBuscar !== undefined && this.inputBuscar.length === 0) {
            if (this.options.length == 1) return '44px'
            if (this.options.length > 2) return '120px'
            else return '82px'
          } else{
            return 'auto'
          }
        }
    },
watch :{
    seleccionado:function(){
      if (Object.entries(this.seleccionado).length !== 0) {
        this.inputBuscar = this.seleccionado.text;
      }
    },
    inputBuscar: function(){
      if(this.inputBuscar !== undefined){
        // console.log("esta definido :) )", this.idSelect);
        if(this.inputBuscar.length === 0){
          // console.log("esta vacio", this.idSelect);
          if(Object.entries(this.seleccionado).length > 0){ ///si hay una opc seleccionada abre la lista y limpia el texto del input
            this.masOptions = true;
            this.inputBuscar = '';
          }
        }else{ 
          // console.log("tiene un valor", this.idSelect);
          this.mHSelect = '200px'
        }
      }else{
        // console.log("esta mal :) ", this.idSelect);
        return
      }
      
    },
    options(){
      deep:{
        this.seteoValueSelect();
        this.indexOption = null; // evita que busque un elemento que pertenece a otra lista
      }
    },
    values: function(){
      deep: {
        this.seteoValueSelect();
        this.$emit('change-select')
        if(this.values == null) {
          this.inputBuscar = '';
          this.seleccionado = [];
        }
      }
    }
}, 
methods:{
  clickOutsideSelect: function(){
    setTimeout(() => this.masOptions = false, 300);
    setTimeout(() => this.interacionSelect(), 300);
  },
  interacionSelect: function(){
    if(Object.entries(this.seleccionado).length !== 0) { //al hacer click fuera del elemento verifica si hay un elemento seleccionado para asignar ese valor al input
        this.inputBuscar = this.seleccionado.text;
    }else{
          this.inputBuscar = '';
    }
  },
  clickDownUpSelect: function(event){
    let listGroup = document.querySelector('#'+this.idSelect+'.items');
    let containerScroll = document.querySelector('#'+this.idSelect);

     // Obtener todos los elementos
    let items = listGroup.querySelectorAll('div');
     // Saber si alguno está activo
    let actual = Array.from(items).findIndex(item => item.classList.contains('active'));
    // Analizar tecla pulsada
    if(event.keyCode == 13) {
        // Tecla Enter, evitar que se procese el formulario
        event.preventDefault();
        // ¿Hay un elemento activo?
        if(items[actual]) {
            // Hacer clic
            items[actual].click();
        }
    } if(event.keyCode == 38 || event.keyCode == 40) {
        // Flecha arriba (restar) o abajo (sumar)
        if(items[actual]) {
            // Solo si hay un elemento activo, eliminar clase
            items[actual].classList.remove('active');
        }
        // Calcular posición del siguiente
        actual += (event.keyCode == 38) ? -1 : 1;
        // Asegurar que está dentro de los límites
        if(actual < 0) {

            actual = 0;
        } else if(actual >= items.length) {
            actual = items.length - 1;
        }
        // Asignar clase activa
        items[actual].classList.add('active');
        let atributosItem = items[actual].getBoundingClientRect();
        let heightOpc = atributosItem.height;
        // console.log("height del item", heightOpc);
        
        let tamY = (heightOpc)-4; // obtener el tamaño de cada opción para hacer el desplazamiento con respecto a eso
        //console.log("tamY", tamY);

        if (event.keyCode == 40) return containerScroll.scrollBy(0, tamY);
        if (event.keyCode == 38) return containerScroll.scrollBy(0, -(tamY));
    }
  },
  seteoValueSelect: async function(){
    if(this.values || this.values === 0 ){
      let valor = await this.options.find(x => x.id === this.values);
      if(valor){
          this.inputBuscar = valor.text;
          this.indexOption = valor.text;
          this.seleccionado = valor;
      }
    }
  },
   seeList: async function(){
    if(!this.disable){
        this.masOptions = !this.masOptions;
        this.inputBuscar = '';
        if(this.masOptions && this.indexOption != null && this.values !== null){
          // console.log("this.indexOption", this.indexOption);

          let containerScroll = document.querySelector('#'+this.idSelect);
          // console.log("containerScroll al declararlo", containerScroll);

          let listGroup = await document.querySelector('#'+this.idSelect+'.items'); //seleccion de la lista de elemento
          // console.log("listGroup", listGroup );

          let items = listGroup.querySelectorAll('div'); //se obtiene los divs hijos del elemento
          //console.log("items", items);

          let elemento = Array.from(items).find(item => item.textContent.trim() === this.indexOption.trim()); // se obtiene el elemento que se selecciono mediante el contenido 
          //console.log("elemento", elemento);

          let actual = await Array.from(items).findIndex(item => item.classList.contains('active')); //selecciono el div que contenga la clase active 
          // console.log("actual seleccionado", actual);
          if(items[actual]) {
            items[actual].classList.remove('active'); /// si existe un div con esa clase se le elimina esa clase
          }
          elemento.className += await " active"; //se le agrega la clase
          //console.log("==========================================");
          let numOpciones = this.options.length
          // console.log("numOpciones", numOpciones);

          await numOpciones<=3?  containerScroll.scrollBy(0, 0) : elemento.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        }
    } else{
      this.masOptions = false;
    }
  }
},
mounted() {
    //this.$emit("KuramaSelect", this.seleccionado);
    this.seteoValueSelect();
  }
};
</script>